import React from 'react';
import { useSelector } from 'react-redux';
import useScroll from '../../hooks/useScroll';
import { DIRECTION } from '../../global-constants';
import NavigatorButton from './NavigatorButton';
import StickySide from '../common/StickySide';

const Navigator = () => {
	const { canScroll, scrollTo, isScrollEnd, isScrollStart } = useScroll();
	const vehicleCount = useSelector((state) => state.vehicles.length);

	const handleNavigator = (e, direction) => {
		scrollTo(direction);
	};

	return (
		<>
			<tr className="sr-only">
				<th colSpan={`${vehicleCount}`} scope="colgroup" id="navigator">
					Navigator
				</th>
			</tr>
			<tr>
				<td
					colSpan={`${vehicleCount}`}
					className="pt-5"
					headers="navigator"
				>
					{canScroll && (
						<StickySide>
							<NavigatorButton
								handleNavigator={handleNavigator}
								direction={DIRECTION.LEFT}
								disabled={isScrollStart}
							/>

							<NavigatorButton
								handleNavigator={handleNavigator}
								direction={DIRECTION.RIGHT}
								disabled={isScrollEnd}
								className="ml-3"
							/>
						</StickySide>
					)}
				</td>
			</tr>
		</>
	);
};

Navigator.propTypes = {};

export default Navigator;
